import { Field, FormikProps, getIn } from "formik";
import * as React from "react";
import { IFormValues } from "src/Interfaces/FormValues";
import ButtonGroup from "../forms/partials/ButtonGroup";
import {countries} from 'src/data/countries';

import { useTranslation, withTranslation, WithTranslation } from 'react-i18next';
interface IStep1Props {
    nextStep: () => void;
    back: () => void;
    setAllFieldsTouched: (key: string) => void;
}

interface IProps extends WithTranslation {
    prop: any;
  }
  
  interface IState {
    state: any;
  }
const Step1 = (props: IStep1Props & FormikProps<IFormValues>,{
    prop,
}: IProps) => {
    const { touched, errors } = props;

    React.useEffect(() => {
        props.validateForm();
    }, []);

    const btnprops = {
        ...props,
        nextStep: () => {
            if (!getIn(errors, "personal")) {
                props.nextStep();
            }
            props.setAllFieldsTouched("personal");
        }
    };
    
    const { t } = useTranslation('info');
    return (
        <div className="col-12 col-md-8 mx-auto">
            <h1 className="my-3">{t(`contactInfomration.title`)}</h1>

            <div className="row">
                <div className="form-group col-12 col-md-6">
                    <label>{t(`contactInfomration.firstName`)}</label>
                    <Field
                        type="text"
                        className="form-control"
                        name="personal.firstname"
                        required={true}
                        placeholder="Hong"
                    />
                    {getIn(errors, "personal.firstname") &&
                        getIn(touched, "personal.firstname") && (
                            <small className="text-danger small">
                                {getIn(errors, "personal.firstname")}
                            </small>
                        )}
                </div>

                <div className="form-group col-12 col-md-6">
                    <label>{t(`contactInfomration.lastName`)}</label>
                    <Field
                        type="text"
                        className="form-control"
                        name="personal.lastname"
                        placeholder="Kong"
                    />
                    {getIn(errors, "personal.lastname") &&
                        getIn(touched, "personal.lastname") && (
                            <small className="text-danger small">
                                {getIn(errors, "personal.lastname")}
                            </small>
                        )}
                </div>

                <div className="form-group col-12">
                    <label>{t(`contactInfomration.Email`)}</label>
                    <Field
                        type="email"
                        className="form-control"
                        name="personal.email"
                        placeholder="simple@centreo.hk"
                    />
                    {getIn(errors, "personal.email") &&
                        getIn(touched, "personal.email") && (
                            <small className="text-danger small">
                                {getIn(errors, "personal.email")}
                            </small>
                        )}
                </div>
        
                <div className="form-group col-12 col-md-6">
                    <label>{t(`contactInfomration.countryCode`)}</label>
                    <Field
                        component="select" 
                        name="personal.country_code"
                        className="form-control"
                    >
                        <option value="" label="Select country code">Select country code</option>
                        {
                            countries.map((country:any) => (
                                <option key={country.name} value={country.callingCodes[0]} label={`${country.name} (${country.callingCodes[0]})`}>{`${country.name} (${country.callingCodes[0]})`}</option>
                            ))
                        }
                    </Field>
                    {getIn(errors, 'personal.country_code') && getIn(touched, 'personal.country_code') && <small className="text-danger small">{getIn(errors, 'personal.country_code')}</small>}
                </div>

                <div className="form-group col-12 col-md-6">
                    <label>{t(`contactInfomration.phoneNumber`)}</label>
                    <Field
                        type="text"
                        className="form-control"
                        name="personal.phone"
                        placeholder="12345678"
                    />
                    {getIn(touched, "personal.phone") &&
                        getIn(errors, "personal.phone") && (
                            <small className="text-danger small">
                                {getIn(errors, "personal.phone")}
                            </small>
                        )}
                </div>
            </div>
        </div>
    );
};

export default Step1;
